import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter, Link } from 'react-router-dom';
import { icons, Toastr, routes as mainRoutes } from 'data/common';
import { withStyles } from '@material-ui/core';
import { logOutUser } from 'data/user/actions';
import environments from '../../environments';

class Menu extends Component {
    static propTypes = {
        history: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired,
        logOutUser: PropTypes.func.isRequired,
        classes: PropTypes.object.isRequired
    };

    _handleDisconnect = () => {
        const { logOutUser, history } = this.props;
        Toastr.confirm(Translator.translate('general.logout.confirmationText'), Translator.translate('general.logout.confirmationTitle'), {
            onYes: () => {
                logOutUser();
                return history.replace('/login');
            }
        });
    };

    _renderItems(userEnvironments) {
        const { classes, profile } = this.props;
        let res = [];
        userEnvironments.map((obj, env) => {
            const routes = obj.path;
            let route = null;
            if (Array.isArray(routes)) {
                for (let aRoute of routes) {
                    if (!route && (profile.get('admin') || profile.getIn(['user_rights', env], []).includes(aRoute.right))) route = aRoute.path;
                }
            } else {
                route = routes;
            }
            if (!route) {
                return null;
            }
            res.push(
                <Link to={route} className={classes.iconContainer} key={route} data-env={env} role="presentation">
                    <img className={`${classes.iconReflexion} _iconReflexion`} src={icons.reflexion} alt={env} />
                    <img className={`${classes.icon} _icon`} src={icons[env]} alt={env} />
                    <img className={`${classes.shadow} _shadow`} src={icons.shadow} alt={env} />
                    <div className={`${classes.menuTooltip} _menuTooltip`}>{Translator.translate(`${env}.menuItem`).toUpperCase()}</div>
                </Link>
            );
        });
        return res;
    }

    _renderAdminMenu(adminRoutes) {
        const { classes } = this.props;
        let res = [];
        adminRoutes.map(route => {
            res.push(
                <Link to={route.path} className={classes.iconContainer} key={route.path} role="presentation">
                    <img className={`${classes.iconReflexion} _iconReflexion`} src={icons.reflexion} alt={route.name} />
                    <img className={`${classes.icon} _icon`} src={icons[route.name]} alt={route.name} />
                    <img className={`${classes.shadow} _shadow`} src={icons.shadow} alt={route.name} />
                    <div className={`${classes.menuTooltip} _menuTooltip`}>
                        {Translator.translate(`general.${route.name}.menuItem`).toUpperCase()}
                    </div>
                </Link>
            );
        });
        return res;
    }
    _renderLogOut() {
        const { classes } = this.props;
        return (
            <div className={classes.iconContainer} key="logout" onClick={this._handleDisconnect} role="presentation">
                <img className={`${classes.iconReflexion} _iconReflexion`} src={icons.reflexion} alt="logout" />
                <img className={`${classes.icon} _icon`} src={icons['logout']} alt="logout" />
                <img className={`${classes.shadow} _shadow`} src={icons.shadow} alt="logout" />
                <div className={`${classes.menuTooltip} _menuTooltip`}>{Translator.translate(`general.logout.tooltip`).toUpperCase()}</div>
            </div>
        );
    }

    render() {
        const { profile, classes } = this.props;

        const userEnvironments = environments
            .getEnvironments()
            .filter((route, env) => {
                if (profile.get('admin')) return true;
                return profile.get('environments') && profile.get('environments').indexOf(env) !== -1;
            })
            .sortBy(env => env.index);
        let items = this._renderItems(userEnvironments);

        if (profile.get('admin')) {
            const adminRoutes = mainRoutes.filter(route => {
                return route.admin;
            });
            items.push(this._renderAdminMenu(adminRoutes));
        }

        items.push(this._renderLogOut());

        // Si l'utilisateur possède plusieurs environnements
        return (
            <div className={classes.appMenuContainer}>
                <div className={classes.appMenu}>{items}</div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        profile: state.data.user
    };
}

const styles = theme => ({
    appMenuContainer: {
        marginTop: 80,
        marginBottom: 80,
        [theme.breakpoints.down('md')]: {
            marginTop: 60
        },
        [theme.breakpoints.down('sm')]: {
            marginTop: 20
        }
    },
    appMenu: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        width: '50%',
        margin: '0 auto',
        [theme.breakpoints.down('sm')]: {
            width: '100%'
        }
    },
    iconContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 'auto',
        margin: 20,
        position: 'relative',
        '&:hover': {
            cursor: 'pointer',
            [theme.breakpoints.down('xl')]: {
                '& ._menuTooltip': {
                    transition: 'all 0.2s ease-in-out',
                    opacity: 100,
                    top: 147
                },
                '& ._icon': {
                    transition: 'all 0.2s ease-in-out',
                    transform: 'translate(0, -0.5em)'
                },
                '& ._iconReflexion': {
                    transition: 'all 0.2s ease-in-out',
                    transform: 'translate(0, -0.5em)',
                    opacity: 0
                },
                '& ._shadow': {
                    transition: 'all 0.2s ease-in-out',
                    transform: 'translate(0, -0.3em)',
                    opacity: 0.3
                }
            },
            [theme.breakpoints.down('lg')]: {
                '& ._menuTooltip': {
                    transition: 'all 0.2s ease-in-out',
                    opacity: 100,
                    top: 147
                },
                '& ._icon': {
                    transition: 'all 0.2s ease-in-out',
                    transform: 'translate(0, -0.5em)'
                },
                '& ._iconReflexion': {
                    transition: 'all 0.2s ease-in-out',
                    transform: 'translate(0, -0.5em)',
                    opacity: 0
                },
                '& ._shadow': {
                    transition: 'all 0.2s ease-in-out',
                    transform: 'translate(0, -0.3em)',
                    opacity: 0.3
                }
            },
            [theme.breakpoints.down('md')]: {
                '& ._menuTooltip': {
                    transition: 'all 0.2s ease-in-out',
                    opacity: 100,
                    top: 117
                }
            },
            [theme.breakpoints.down('sm')]: {
                '& ._menuTooltip': {
                    transition: 'all 0.2s ease-in-out',
                    opacity: 100,
                    top: 75
                },
                '& ._icon': {
                    transition: 'all 0.2s ease-in-out',
                    transform: 'translate(0, -0.3em)'
                },
                '& ._iconReflexion': {
                    transition: 'all 0.2s ease-in-out',
                    transform: 'translate(0, -0.3em)',
                    opacity: 0
                },
                '& ._shadow': {
                    transition: 'all 0.2s ease-in-out',
                    transform: 'translate(0, -0.2em)',
                    opacity: 0.3
                }
            }
        },
        [theme.breakpoints.down('sm')]: {
            '& ._menuTooltip': {
                transition: 'all 0.2s ease-in-out',
                opacity: 100,
                top: 75
            }
        }
    },
    menuTooltip: {
        transition: 'all 0.2s ease-in-out',
        opacity: 0,
        top: 120,
        position: 'absolute',
        width: 'auto',
        margin: '0 auto',
        textAlign: 'center',
        color: '#ffffff',
        zIndex: 1,
        [theme.breakpoints.down('md')]: {
            transition: 'all 0.2s ease-in-out',
            opacity: 0,
            top: 90
        },
        [theme.breakpoints.down('sm')]: {
            transition: 'all 0.2s ease-in-out',
            opacity: 0,
            top: 45,
            fontSize: '0.8em'
        }
    },
    iconReflexion: {
        transition: 'all 0.2s ease-in-out',
        position: 'absolute',
        width: 150,
        height: 150,
        zIndex: 3,
        opacity: 0.2,
        [theme.breakpoints.down('md')]: {
            transition: 'all 0.2s ease-in-out',
            width: 120,
            height: 120
        },
        [theme.breakpoints.down('sm')]: {
            transition: 'all 0.2s ease-in-out',
            width: 70,
            height: 70
        }
    },
    icon: {
        transition: 'all 0.2s ease-in-out',
        position: 'absolute',
        width: 150,
        height: 150,
        zIndex: 2,
        [theme.breakpoints.down('md')]: {
            transition: 'all 0.2s ease-in-out',
            width: 120,
            height: 120
        },
        [theme.breakpoints.down('sm')]: {
            transition: 'all 0.2s ease-in-out',
            width: 70,
            height: 70
        }
    },
    shadow: {
        boxShadow: 'none',
        transition: 'all 0.2s ease-in-out',
        position: 'relative',
        zIndex: 1,
        width: 160,
        height: 160,
        [theme.breakpoints.down('md')]: {
            transition: 'all 0.2s ease-in-out',
            width: 128,
            height: 128
        },
        [theme.breakpoints.down('sm')]: {
            transition: 'all 0.2s ease-in-out',
            width: 75,
            height: 75
        }
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators(Object.assign({}, { logOutUser }), dispatch)
    )(withStyles(styles, { withTheme: true })(Menu))
);



// WEBPACK FOOTER //
// ./scenes/Menu/index.js